// src/pages/Operations.js
import React from 'react';
import './Operation.css';

export default function Operations() {
  const sections = [
    {
      title: '조직 구조',
      items: [
        '운영팀: 커뮤니티 리더(코디네이터), 자원봉사자, 전문 강사(영양사, 운동 트레이너, 교육 전문가 등)',
        '회원 소그룹: 관심사(건강식, 운동, 교육)별로 소그룹을 구성해 소속감을 강화',
        '자문단: 의료 전문가, 심리 상담사, 저속노화 전문가를 초빙해 프로그램 자문',
      ],
    },
    {
      title: '회원 기본 제공 프로그램',
      items: [
        '월2회 디지털 기초역량 온라인 학습지 비타민 제공',
        '월1회 시니어에 최적화된 온라인 뉴스레터',
        '에버영코리아 채용 정보 기본 제공',
      ],
    },
  ];

  // 키워드(콜론 앞부분) 분리 함수 (첫 박스 전용)
  const renderItem = (text, needKeywordSplit) => {
    if (!needKeywordSplit) return text;
    const [keyword, ...rest] = text.split(':');
    const remain = rest.join(':').trim();
    return (
      <>
        <span className="method-keyword">{keyword}</span>
        {remain && `: ${remain}`}
      </>
    );
  };

  return (
    <>
      {/* ───────── 데스크톱 ───────── */}
      <div className="methods-page only-desktop">
        <h1 className="method-title">운영방법</h1>
        <p className="method-subtitle">
          커뮤니티 운영은 체계적이고 지속 가능해야 하며, 회원들의 참여와 만족도를 높이는 방향으로 운영한다
        </p>

        <div className="method-section">
          {sections.map((sec, i) => (
            <div className="method-box" key={`pc-${i}`}>
              <h2>{sec.title}</h2>
              <ul>
                {sec.items.map((it, j) => (
                  <li key={`pc-${i}-${j}`}>
                    {renderItem(it, i === 0)}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* ───────── 모바일 ───────── */}
      <div className="methods-page only-mobile">
        <h1 className="method-title">운영방법</h1>
        <p className="method-subtitle mobile">
          커뮤니티 운영은 체계적이고 지속 가능<br /> 
          해야 하며, 회원들의 참여와 만족도를<br /> 
          높이는 방향으로 운영한다
        </p>

        <div className="method-section mobile">
          {sections.map((sec, i) => (
            <div className="method-box mobile" key={`mo-${i}`}>
              <h2>{sec.title}</h2>
              <ul>
                {sec.items.map((it, j) => (
                  <li key={`mo-${i}-${j}`}>
                    {renderItem(it, i === 0)}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
